import styles from "./index.module.scss"
import React, { useState } from "react"
import Input from "../../../../atoms/Input"
import { toast } from "@stardust-ds/react"
import Button from "../../../../atoms/Button"
import { usePlanContext } from "../../context"
import intl from "react-intl-universal"

export default function VoucherForm() {
  const { validateVoucher } = usePlanContext()
  const [cVoucherCode, setVoucherCode] = useState("")
  const [bIsSubmitting, setIsSubmitting] = useState(false)

  const fnHandleSubmit = async (evtSubmit) => {
    evtSubmit.preventDefault()
    if (!cVoucherCode) return
    setIsSubmitting(true)
    try {
      await validateVoucher(cVoucherCode)
      toast({
        type: "success",
        title: intl.get("plan.voucher.success_title"),
      })
    } catch (oError) {
      toast({
        type: "error",
        title: oError.errors,
      })
    }
    setIsSubmitting(false)
  }

  return (
    <form onSubmit={fnHandleSubmit} className={styles.form}>
      <div className={styles.voucherInput}>
        <Input
          isFullWidth
          label={intl.get("plan.voucher.form_title")}
          type="text"
          onChange={(evtChange) => setVoucherCode(evtChange.target.value)}
        />
      </div>
      <div className={styles.submitButton}>
        <Button
          variant="outline"
          type="submit"
          disabled={!cVoucherCode || bIsSubmitting}
          loading={bIsSubmitting || undefined}
        >
          {intl.get("plan.voucher.apply")}
        </Button>
      </div>
    </form>
  )
}
